import { render } from "./notSupportedBrowser.vue?vue&type=template&id=3ffd8599"
import script from "./notSupportedBrowser.vue?vue&type=script&lang=js"
export * from "./notSupportedBrowser.vue?vue&type=script&lang=js"

import "./notSupportedBrowser.vue?vue&type=style&index=0&id=3ffd8599&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__